const Initialarray = {
    locale: {
        languageId: 'english',
        locale: 'en',
        name: 'English',
        icon: 'us'
    }
}

export default function Setting(state = Initialarray, action) {
    switch (action.type) {
        case "SWITCH_LANGUAGE":
            state = {
                ...state,
                locale: action.locale
            }
            break;
        default:

            break;
    }
    return state;
}